module.exports = __webpack_public_path__ + "static/media/smallGreenTemplate.4e3cab2f.png";